"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = void 0;
var _theme = require("../../../../theme");
/* eslint-disable quote-props */

var useStyles = (0, _theme.makeStyles)(function (_ref) {
  var _ref$palette = _ref.palette,
    primary = _ref$palette.primary,
    text = _ref$palette.text,
    typography = _ref.typography;
  return {
    root: {
      position: 'fixed',
      top: 0,
      left: 0,
      paddingRight: '12px',
      width: '100vw',
      height: '48px',
      display: 'flex',
      justifyContent: 'flex-end',
      alignItems: 'center',
      color: '#efefef',
      zIndex: 900,
      textTransform: 'none',
      background: 'transparent',
      '& .MuiButton-label': {
        marginLeft: 0,
        '& span:nth-of-type(2)': {
          margin: '0 4px'
        }
      }
    },
    flagText: {
      fontFamily: 'Source Sans Pro',
      lineHeight: '19px',
      fontStyle: 'normal',
      fontWeight: 600,
      color: '#212529',
      fontSize: '13px',
      verticalAlign: 'middle',
      marginLeft: '4px',
      textTransform: 'none'
    },
    flagCombine: {
      width: '98px',
      height: '26px',
      lineHeight: '20.5px',
      flexShrink: 0,
      paddingRight: '22px'
    },
    flag: {
      display: 'inline-block',
      verticalAlign: 'middle',
      height: '15px'
    },
    wrapperRight: {
      height: '100%',
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'flex-end',
      alignItems: 'center',
      '& > div:first-child > button': {
        minWidth: '16px',
        top: ' 1px'
      }
    },
    menuButton: {
      width: '27px',
      height: '34px',
      textAlign: 'center',
      position: 'relative',
      transform: 'rotate(0deg)',
      transition: '.5s ease-in-out',
      cursor: 'pointer',
      minWidth: '16px',
      '& > span': {
        display: 'block',
        position: 'absolute',
        height: '2px',
        width: '16px',
        background: '#fff',
        borderRadius: '9px',
        opacity: 1,
        left: '7px',
        transform: 'rotate(0deg)',
        transition: '.25s ease-in-out',
        '&:nth-child(1)': {
          top: '10px'
        },
        '&:nth-child(2)': {
          top: '15px'
        },
        '&:nth-child(3)': {
          top: '20px'
        }
      },
      '&.open > span': {
        '&:nth-child(1)': {
          top: '16px',
          transform: 'rotate(135deg)'
        },
        '&:nth-child(2)': {
          opacity: 0,
          left: '-10px'
        },
        '&:nth-child(3)': {
          top: '16px',
          transform: 'rotate(-135deg)'
        }
      },
      '&:hover': {
        backgroundColor: 'transparent'
      }
    },
    menuButtonText: {
      fontSize: '10px',
      position: 'absolute',
      top: '25px',
      left: '4px'
    },
    disabledButton: {
      fontFamily: "'Source Sans Pro', 'Helvetica Neue', Helvetica, Arial, sans-serif",
      fontSize: '13px',
      letterSpacing: 0.2,
      maxHeight: '100%',
      color: '#ffffff',
      padding: '13px 20px',
      borderRadius: 0,
      fontWeight: 500,
      pointerEvents: 'none',
      '& > span': {
        color: '#d3d3d3'
      }
    },
    button: {
      fontFamily: "'Source Sans Pro', 'Helvetica Neue', Helvetica, Arial, sans-serif",
      fontSize: '13px',
      letterSpacing: 0.2,
      maxHeight: '100%',
      color: primary.main,
      padding: '0 24px 4px 16px',
      borderRadius: 0,
      fontWeight: 500,
      '&:hover': {
        backgroundColor: 'transparent',
        '& > span': {
          backgroundColor: 'transparent',
          minWidth: '16px'
        }
      },
      '& > .APMenu-spacer': {
        margin: '0 4px'
      }
    },
    userName: {
      color: text.primary,
      textTransform: 'capitalize',
      fontSize: '13px',
      fontWeight: typography.fontWeightSemiBold,
      lineHeight: '21px'
    },
    accountName: {
      fontSize: '13px',
      fontWeight: typography.fontWeightRegular
    },
    badge: {
      '& .MuiBadge-badge': {
        color: '#fff',
        minWidth: '13px',
        height: '13px',
        padding: '16px'
      },
      padding: '16px'
    },
    bell: {
      height: '16px',
      width: '14px',
      cursor: 'pointer'
    },
    iconButton: {
      width: '48px',
      height: '48px',
      padding: 0,
      minWidth: '48px',
      '&:hover': {
        background: 'transparent',
        color: 'transparent'
      }
    }
  };
}, {
  name: 'PortalHeaderLight'
});
exports.useStyles = useStyles;